import { useMatches } from 'react-router'

interface RouteHandle {
  title?: string
}

export function DocumentTitle() {
  const matches = useMatches()

  // Find the last route with a title handler
  const lastMatchWithTitle = [...matches].reverse().find((match) => {
    const handle = match.handle as RouteHandle
    return handle?.title
  })

  const title = lastMatchWithTitle?.handle ? (lastMatchWithTitle.handle as RouteHandle).title : null

  return <title>{title ? `EnGen | ${title}` : 'EnGen'}</title>
}
